import React, { createContext, useContext, useState } from "react";
import { patchRequest, postRequest } from "services/api";
import { ACTION_TYPES, URLS } from "utils/constants";

const LabelCreateContext = createContext();

export const LabelCreateProvider = ({ children }) => {
  // {
  //   "name": "Label 1", // required
  //   "color": "#000000" // required | maksimal 7 char
  // }
  const [label, setLabel] = useState({
    form: {
      name: "",
      color: "",
    },
    data: null,
    loading: false,
    error: null,
    isSubmitting: false,
    mode: ACTION_TYPES.CREATE,
  });

  const createLabel = async () => {
    setLabel((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));

    try {
      const response = await postRequest("/label", label.form);
      console.log(response);
      if (response.success) {
        setLabel((prevState) => ({
          ...prevState,
          data: response.data,
          error: null,
          isSubmitting: false,
        }));

        return { success: true, data: response };
      }
    } catch (error) {
      setLabel((prevState) => ({
        ...prevState,
        error: "Failed to create label",
        isSubmitting: false,
      }));

      return { success: false, error: error };
    }
  };

  const updateLabel = async (id) => {
    setLabel((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));

    try {
      const response = await patchRequest(`/label/${id}`, label.form);
      if (response.success) {
        setLabel((prevState) => ({
          ...prevState,
          data: response.data,
          error: null,
          isSubmitting: false,
        }));

        return { success: true, data: response };
      }
    } catch (error) {
      setLabel((prevState) => ({
        ...prevState,
        error: "Failed to update label",
        isSubmitting: false,
      }));

      return { success: false, error: error };
    }
  };

  const resetLabel = () => {
    setLabel((prevState) => ({
      ...prevState,
      form: {
        name: "",
        color: "",
      },
      data: null,
      error: null,
      isSubmitting: false,
      mode: ACTION_TYPES.CREATE,
    }));
  };

  return (
    <LabelCreateContext.Provider
      value={{ label, createLabel, updateLabel, resetLabel }}
    >
      {children}
    </LabelCreateContext.Provider>
  );
};

export const useLabelCreate = () => {
  const context = useContext(LabelCreateContext);
  if (!context) {
    throw new Error("useLabelCreate must be used within LabelCreateProvider");
  }
  return context;
};
